import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: '[lib-total-row]',
  templateUrl: './total-row.component.html',
  styleUrls: ['./total-row.component.css']
})
export class TableTotalRowComponent implements OnInit {

  @Input() totalrow: any;
  @Input() noData: boolean;
  @Input() indexCons;
  @Input() totalRowConf;

  constructor() { }

  ngOnInit() {
  }

  totalCol(data: object) {
    return (data && data['dataType'] && (data['dataType'].indexOf("LOCATION") >= 0 || data['dataType'].indexOf("LOCATION_DISABLED") >= 0 || data['dataType'].indexOf("LOCATION_WITH_DESCRIPTION") >= 0 || data['dataType'].indexOf("TOTAL") >= 0));
  }
}
